<div class="bpx-dialog bpx-dialog--wide column-selection-dialog">
  <h2 mat-dialog-title>{{ columns.length ? 'Select Columns' : 'Report Options' }}</h2>
  <mat-dialog-content>
    @if (offerPaginationInfo) {
      <details class="option-group" [open]="paginationInfoRequired">
        <summary class="option-group__summary">
          <span class="option-group__title">Report Pagination Information</span>
          <span class="option-group__state">{{ paginationInfoSummary() }}</span>
        </summary>
        <div class="option-group__body pagination-info">
          <div class="pagination-info__fields">
            <label class="pagination-info__field">
              <span>Material Number
                @if (paginationInfoRequired) {
                  <span class="pagination-info__required" aria-hidden="true">*</span>
                }
              </span>
              <input type="text" class="bpx-editable" name="materialNumber" maxlength="40"
                [required]="paginationInfoRequired" [(ngModel)]="materialNumber" />
            </label>
            <label class="pagination-info__field">
              <span>Batch Number
                @if (paginationInfoRequired) {
                  <span class="pagination-info__required" aria-hidden="true">*</span>
                }
              </span>
              <input type="text" class="bpx-editable" name="batchNumber" maxlength="40"
                [required]="paginationInfoRequired" [(ngModel)]="batchNumber" />
            </label>
          </div>
          @if (paginationInfoRequired) {
            @if (isPaginationInfoIncomplete()) {
              <span class="option-group__hint">Both are required and print in the report footer.</span>
            }
          } @else {
            <span class="option-group__hint">Optional. Each prints in the report footer when entered.</span>
          }
        </div>
      </details>
    }
    @if (offerRunDetails) {
      <details class="option-group">
        <summary class="option-group__summary">
          <span class="option-group__title">Report Contents</span>
          <span class="option-group__state">{{ runDetailsSummary() }}</span>
        </summary>
        <div class="option-group__body run-details">
          <mat-checkbox [checked]="includeRunDetails" (change)="toggleRunDetails($event)">
            Include worklist and report items
          </mat-checkbox>
          <span class="option-group__hint option-group__hint--checkbox">
            Appends the run setup worklist and the report content items to the end of the report.
          </span>
        </div>
      </details>
    }
    @if (offerResultBasis) {
      <!-- Not bound to the empty state: re-checking a half would then snap the box shut under
           the pointer. The summary states "None selected", which is what Apply is disabled on. -->
      <details class="option-group">
        <summary class="option-group__summary">
          <span class="option-group__title">Results to Include</span>
          <span class="option-group__state">{{ resultBasisSummary() }}</span>
        </summary>
        <div class="option-group__body result-basis">
          <mat-checkbox [checked]="includeUnadjusted" (change)="toggleUnadjusted($event)">Unadjusted</mat-checkbox>
          <mat-checkbox [checked]="includeAdjusted" (change)="toggleAdjusted($event)">Adjusted</mat-checkbox>
        </div>
      </details>
    }
    @if (columns.length) {
    <div class="column-selection-actions" *ngIf="columns.length > 1">
      <button type="button" class="bpx-btn" (click)="selectAll()">Select All</button>
      <button type="button" class="bpx-btn" (click)="clearAll()" [disabled]="isSelectionEmpty()">Clear All</button>
    </div>
    <div class="bpx-scroll-card column-selection-scroll">
      <table class="selection-table">
        <thead>
          <tr>
            <th class="checkbox-cell"></th>
            @for (heading of headings; track heading) {
              <th>{{ heading }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (column of columns; track trackByKey($index, column)) {
            <tr>
              <td class="checkbox-cell">
                <mat-checkbox [checked]="isChecked(column)" (change)="toggleColumn(column, $event)"></mat-checkbox>
              </td>
              @for (cell of cells(column); track $index) {
                <td>{{ cell }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" class="bpx-btn bpx-btn--primary" matRipple [disabled]="isApplyDisabled()"
      (click)="applySelection()">Apply</button>
    <button type="button" class="bpx-btn" matRipple (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
